import React, { createContext, useState, useEffect } from "react";
import { ShowToast, Severty } from "../helper/toast";
import { settingsAPI } from "../services/api";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [activeDevices, setActiveDevice] = useState();
  const [isLoading, setLoading] = useState(false);

  //get feedback
  const getFeedback = async () => {
    try {
      const response = await settingsAPI.getFeedbacks();
      if (response.status === 200 && response.data) {
        return { success: true, data: response };
      } else {
        console.warn("Failed to load content:", response.message);
        return { success: false, error: response.message };
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        error.error ||
        "Failed to fetch content. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
    }
  };

  // submit feedback
  const submitFeedback = async (feedbackData) => {
    try {
      setLoading(true);
      const response = await settingsAPI.submitFeedback(feedbackData);
      if (response.status === 201 && response.data) {
        return { success: true, data: response };
      } else {
        console.warn("Failed to submit feedback:", response.message);
        return { success: false, error: response.message };
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        error.error ||
        "Failed to submit feedback. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // get all user active devices
  const getActiveDevices = async () => {
    try {
      const response = await settingsAPI.activeDevices();
      if (response.status === 200 && response.data) {
        setActiveDevice(response.data.devices);
        return { success: true, data: response.data };
      } else {
        console.warn("Failed to load content:", response.message);
        return { success: false, error: response.message };
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        error.error ||
        "Failed to fetch content. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    }
  };

  // device revoke
  const revokeDevice = async (deviceId, single = true) => {
    try {
      setLoading(true);

      // call the API
      const response = await settingsAPI.revokeDevice(deviceId, single);

      if (response?.status === 200 && response?.data) {
        ShowToast("Device revoked successfully!", Severty.SUCCESS);

        return { success: true, data: response.data };
      } else {
        console.warn("Failed to revoke device:", response?.message);
        return { success: false, error: response?.message };
      }
    } catch (error) {
      const errorMessage =
        error?.message ||
        error?.error ||
        "Failed to revoke device. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // content list
  const getContent = async (contentType, lng) => {
    try {
      const response = await settingsAPI.cmsManagement(contentType, lng);

      if (response.status === 200 && response.data) {
        return { success: true, data: response };
      } else {
        console.warn("Failed to load content:", response.message);
        return { success: false, error: response.message };
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        error.error ||
        "Failed to fetch content. Please try again.";
      ShowToast(errorMessage, Severty.ERROR);
      return { success: false, error: errorMessage };
    } finally {
    }
  };

  // Get Surveys
  const getSurveys = async () => {
    try {
      const response = await settingsAPI.getSurveys();
      return response;
    } catch (error) {
      throw error;
    }
  };

  //Vote surveys
  const voteSurvey = async (data) => {
    try {
      const response = await settingsAPI.voteSurvey(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return (
    <SettingsContext.Provider
      value={{
        activeDevices,
        isLoading,
        getFeedback,
        getContent,
        getActiveDevices,
        submitFeedback,
        revokeDevice,
        setActiveDevice,
        setLoading,
        getSurveys,
        voteSurvey,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

// Custom hook to use the wallet context
export const useSettings = () => {
  const context = React.useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useWallet must be used within a WalletProvider");
  }
  return context;
};
